import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
var Base64 = require('js-base64').Base64;

@Component({
    selector: "sccntt-sso",
    template: "<div>SSO: {{loginErrorStatus}}</div>"
})
export class SSOComponent implements OnInit {
    constructor( private route:ActivatedRoute, private router: Router, private authService: AuthService ) { }
    loginErrorStatus:string ="";
    ngOnInit() { 
        var token = this.route.snapshot.params["token"];
        var id_token = this.route.snapshot.params["id_token"];
        localStorage.setItem("scnntttoken", token);
        localStorage.setItem("scnnttidtoken", id_token);
        var today = new Date();
        var newDateObj = new Date();
        newDateObj.setTime(today.getTime() + (60 * 60 * 1000));
        localStorage.setItem("expires", newDateObj.toString());
        this.authService.getUserRolesInfo(token, "quyen").subscribe(
            (info: any) => {
                this.authService.dsRoutes = info.routesInfo;
                this.authService.user = info.userInfo;
                var jsonString = JSON.stringify(info);
                var encodedString = Base64.encode(jsonString);
                localStorage.setItem("userInfo", encodedString);
                if (this.authService.redirectUrl == null || this.authService.redirectUrl == undefined)
                    // this.router.navigate(['./xl-xu-ly-su-co/xu-ly-su-co-new']);
                    this.router.navigate(['./phan-anh/browse']);
                else
                    this.router.navigate([this.authService.redirectUrl]);
                this.authService.isLoggedIn = true;
                this.authService.showHeader = true;
                this.authService.showFooter = true;
            },
            (e) => {
                this.loginErrorStatus = "Lỗi: Hệ thống có lỗi kết nối sso, xin vui lòng liên hệ người quản trị";
                console.log(e);
            });
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/login/sso.component.ts